import { WithdrawalType } from '@models/user/enums';

export interface WithdrawalFeeEntry {
    feeAmount: number;
    feeType: FeeType;
    paymentMethod: WithdrawalType;
}

type WithdrawalFeesSetting = Record<WithdrawalType, WithdrawalFeeEntry>;

export interface WithdrawalFees {
    withdrawalFeeEnabled: boolean;
    withdrawalFeeEndPeriod: null | Date;
    withdrawalFeesSettings: WithdrawalFeesSetting;
    freeWithdrawalsLeft: number;
}

export enum FeeType {
    Percentage = 'Percentage',
    FixedAmount = 'FixedAmount',
}
